module.exports = __webpack_public_path__ + "static/media/logo-ichong.4c4aa12c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pic/logo-ichong.png
// module id = 1076
// module chunks = 58